
import { Component, Vue } from 'vue-property-decorator'
import { apiAliyunLiveConfigGet, apiAliyunLiveConfigSet } from '@/api/setting'

@Component
export default class AliyunLiveConfig extends Vue {
    form: any = {
        access_key_id: '',
        access_key_secret: '',
        push_domain: '',
        pull_domain: '',
        app_name: 'live',
        auth_key: '',
        auth_expire: 3600,
        status: 0
    }
    submitting = false

    created() {
        this.getConfig()
    }

    getConfig() {
        apiAliyunLiveConfigGet().then((res: any) => {
            this.form = { ...this.form, ...res }
        })
    }

    onSubmit(formName: string) {
        const refs = this.$refs[formName] as HTMLFormElement
        refs.validate((valid: boolean) => {
            if (!valid) return
            this.submitting = true
            apiAliyunLiveConfigSet(this.form)
                .then(() => {
                    this.$message.success('保存成功')
                })
                .finally(() => {
                    this.submitting = false
                })
        })
    }
}
